<template>
  <div class="workarea row justify-content-center">
    <b-modal ref="removeConfirmation" id="removeConfirmation" title="Ta bort medlem" @ok="removeAction" @cancel="removeCancel" close-title="Nej" ok-title="Ja">
        <span>Vill du ta bort medlemmen?</span>
    </b-modal>
    <b-modal ref="passwordReset" id="passwordReset" title="Ändra Lösenord" @ok="changePassword" @cancel="changePasswordCancel" close-title="Avbryt" ok-title="Ändra">
        <b-form-input type="password" v-model="password" name="password" placeholder="Lösenord"></b-form-input>
    </b-modal>
    <b-modal ref="createUser" id="createUser" title="Skapa Användare" @ok="createUser" @cancel="createUserCancel" close-title="Avbryt" ok-title="Skapa">
        <b-form-fieldset
            label="Användarnamn"
            :state="errors.has('username') ? 'danger' : 'success'">
            <b-form-input v-model="username" name="username" v-validate:username.initial="'required|alpha_num|min:2'" placeholder="Användarnamn"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
            label="Lösenord"
            :state="(errors.has('password:required') || errors.has('password:min')) ? 'danger' : 'success'">
            <b-form-input type="password" v-model="password" name="password" v-validate:password.initial="'required|min:6|confirmed:confirm'" placeholder="Lösenord"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
            label="Repetera lösenord"
            :state="errors.has('password:confirmed') ? 'danger' : 'success'">
            <b-form-input type="password" name="confirm" v-model="passwordConfirm" placeholder="Repetera lösenord"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
            label="E-mail"
            :state="errors.has('email') ? 'danger' : 'success'">
            <b-form-input type="email" v-model="email" name="email" v-validate:email.initial="'required|email'" placeholder="E-mail"></b-form-input>
        </b-form-fieldset>
    </b-modal>
    <div class="col-md-8">
        <div class="row">
            <div class="col-sm-6">
                <h2>Medlemmar</h2>
            </div>
            <div class="col-sm-5">
                <div class="input-group">
                    <Autocomplete :options="getFriends()" v-model="username">
                        <template slot="item" scope="option">
                            <p><strong>{{ option.title }}</strong></p>
                        </template>
                    </Autocomplete>
                    <span class="input-group-btn">
                        <button @click="create({organisation, user: username, permission: 0, index})" type="button" class="btn btn-md btn-primary">Lägg till</button>
                    </span>
                </div>
            </div>
            <div class="col-sm-1 fix">
                <button @click="createUserShow()" type="button" class="btn btn-md btn-primary">Ny</button>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Namn</th>
                    <th>Nivå</th>
                    <th>Hantera</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(member, memberIndex) in members">
                    <td v-if="member.user_id === userId || current_member.permission_level < 1">{{ member.user }}</td>
                    <td v-else><a href="#" v-on:click.stop.prevent="selectForPassword({organisation, member, index, memberIndex})" v-if="member.user_id !== userId">{{ member.user }}</a></td>
                    <td v-if="member.user_id === userId">{{ memberPermissionLevel(member) }}</td>
                    <td v-else>
                        <b-form-select :value="member.permission_level" :options="permissions" @input="value => updatePermission(value, member)" class="mb-3">
                        </b-form-select>
                    </td>
                    <td>
                        <button class="btn btn-primary" v-on:click="selectForRemoval({organisation, member, index, memberIndex})" v-if="member.user_id !== userId">Ta bort</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import Autocomplete from '@/components/parts/Autocomplete'

export default {
    name: 'workarea',
    components: {
        Autocomplete
    },
    computed: {
        userId () {
            return this.$store.state.authentication.user.id
        },
        organisations () {
            return this.$store.state.organisations.organisations
        },
        members () {
            return _.orderBy(this.organisation.members, 'user')
        },
        organisation () {
            return this.$store.getters.getOrganisation(this.$route.params.id)
        },
        index () {
            return _.indexOf(this.organisations, this.organisation)
        },
        current_member () {
            let index = _.findIndex(this.organisation.members, {user_id: this.userId})
            return this.organisation.members[index]
        }
    },
    data () {
        return {
            username: '',
            member: null,
            permissions: [
                {text: 'Medlem', value: 0},
                {text: 'Moderator', value: 1},
                {text: 'Administrator', value: 2},
                {text: 'Super Administrator', value: 3}
            ],
            permission: 0,
            password_member: null,
            password: '',
            email: '',
            passwordConfirm: ''
        }
    },
    mounted () {
        this.refresh({organisation: this.organisation, index: this.index})
    },
    methods: {
        ...mapActions({
            refresh: 'organisation_members',
            remove: 'organisation_member_delete',
            create: 'organisation_member_post',
            update_permission: 'organisation_member_permission',
            update_password: 'organisation_member_password',
            register_member: 'auth_register_member'
        }),
        ...mapGetters({
            getFriends: 'getFriendsList'
        }),
        selectForRemoval: function ({organisation, member, index, memberIndex}) {
            this.member = {organisation, member, index, memberIndex}
            this.$refs.removeConfirmation.show()
        },
        removeAction: function () {
            console.log('REMOVE', this.member)
            this.remove(this.member)
        },
        removeCancel: function () {
            this.member = null
        },
        createUserShow: function () {
            this.$refs.createUser.show()
        },
        createUserCancel: function () {
            this.password = ''
            this.passwordConfirm = ''
            this.username = ''
        },
        createUser: function () {
            if (this.username.length > 2 && this.password.length > 6 && this.password === this.passwordConfirm) {
                this.register_member({ username: this.username, password: this.password, email: this.email, organisation: this.organisation, permission: 0 }).then(() => {
                    this.refresh({organisation: this.organisation, index: this.index})
                    this.password = ''
                    this.passwordConfirm = ''
                    this.username = ''
                })
            }
        },
        selectForPassword: function ({organisation, member, index, memberIndex}) {
            this.password_member = {organisation, member, index, memberIndex}
            this.$refs.passwordReset.show()
        },
        changePassword: function () {
            this.update_password({organisation: this.organisation, member: this.password_member.member, password: this.password, index: this.index})
        },
        changePasswordCancel: function () {
            this.password_member = null
        },
        memberPermissionLevel: function (member) {
            let level = ''

            switch (member.permission_level) {
            case 0: {
                level = 'Medlem'
                break
            }
            case 1: {
                level = 'Moderator'
                break
            }
            case 2: {
                level = 'Administrator'
                break
            }
            case 3: {
                level = 'Super Administrator'
                break
            }
            };

            return level
        },
        updatePermission: function (value, member) {
            if (value !== member.permission_level) {
                this.update_permission({organisation: this.organisation, member, permission: value, index: this.index})
            }
        }
    }
}
</script>

<style lang="scss">
.fix {
    margin-left: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisation.vue